module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00039-fs8.b8fd871.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00039-fs8.png
// module id = 192
// module chunks = 0